<template>
  <hm-sync :value="value">
    <div>
      <div class="table-panel flex flex-between">
        <div>
          <el-button
            class="mr10"
            type="primary"
            size="small"
            :disabled="value"
            @click="addBrand"
            >添加品牌</el-button
          >
          <el-button
            type="primary"
            size="small"
            @click="importTempVisible = true"
            :disabled="value"
            >品牌导入</el-button
          >
        </div>
        <div>
          <el-input
            clearable
            v-model.trim="keyWords"
            placeholder="搜索品牌"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-button type="primary" size="small" @click="search"
            >查询</el-button
          >
          <el-button
            type="success"
            size="small"
            @click="output"
            :loading="isOutputing"
            >导出</el-button
          >
        </div>
      </div>

      <div class="table">
        <el-table
          @sort-change="sortChange"
          stripe
          border
          ref="brandTable"
          :data="allBrandActivityList.records"
          style="width: 100%"
          id="table"
          size="small"
          :default-sort="{ prop: 'num', order: 'descending' }"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="编号"
            :index="index => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="brandName"
            label="品牌名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            show-overflow-tooltip
            align="center"
            prop="brandLogo"
            label="品牌logo图"
          >
            <template slot-scope="scope">
              <img
                :src="scope.row.brandLogo"
                alt
                style="width:60px;height:60px"
                v-if="scope.row.brandLogo"
              />
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="brandAcronym"
            label="品牌首字母"
            sortable
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="seqNum"
            label="排序"
            sortable
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="是否显示"
            prop="isSalesEndDisplay"
            sortable
          >
            <template slot-scope="scope">
              <span v-if="scope.row.isSalesEndDisplay == 'true'" class="success"
                >显示</span
              >
              <span v-else class="danger">隐藏</span>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="relationSpu"
            label="相关商品"
            sortable
          ></el-table-column>
          <el-table-column label="操作" header-align="center" align="center">
            <template slot-scope="scope">
              <div class="flex flex-center">
                <el-tooltip class="item" content="查看" placement="top">
                  <!-- <el-button
                    size="small"
                    @click="toDetails(scope.row)"
                    icon="hmicon icon-chakan blue"
                  ></el-button>-->
                  <button
                    class="pointer mr10 no-bg"
                    @click="toDetails(scope.row)"
                  >
                    <span class="hmicon icon-chakan blue"></span>
                  </button>
                </el-tooltip>
                <el-tooltip class="item" content="编辑" placement="top">
                  <button
                    class="pointer mr10 no-bg"
                    :disabled="value"
                    @click="edit(scope.row)"
                  >
                    <span
                      class="hmicon icon-bianji"
                      :class="value ? 'gray' : 'blue'"
                    ></span>
                  </button>
                </el-tooltip>
                <el-tooltip class="item" content="删除" placement="top">
                  <button
                    class="pointer mr10 no-bg"
                    :disabled="
                      scope.row.syncFlag == 'hemiao' && scope.row.syncFlag == 0
                    "
                    @click="remove(scope.row)"
                  >
                    <span
                      class="hmicon icon-shanchu"
                      :class="
                        scope.row.syncFlag == 'hemiao' &&
                        scope.row.syncFlag == 0
                          ? 'gray'
                          : 'primary'
                      "
                    ></span>
                  </button>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="allBrandActivityList.total"
          @current-change="paging"
          @size-change="handleSizeChange"
          :page-sizes="[10, 50, 100, 200]"
          layout="total, sizes,  prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <hm-import-temp
      :tHeader="tHeader"
      :tBody="tBody"
      @close="importTempVisible = false"
      @importSuccess="importSuccess"
      title="品牌导入"
      filterText="brandName"
      :visible="importTempVisible"
    ></hm-import-temp>
  </hm-sync>
</template>

<script>
import HmSync from "@/components/HmIsSync";
import { mapGetters } from "vuex";
import { setCookie, getCookie } from "@/utils/utils";
import HmImportTemp from "@/components/HmImportTemp";
export default {
  components: { HmSync, HmImportTemp },
  data() {
    return {
      sort: {},
      tHeader: ["品牌名称（必填）", "品牌首字母（单字母需大写）"],
      tBody: ["brandName", "brandAcronym"],
      pageSize: 10,
      value: false,
      keyWords: "",
      isOutputing: false,
      currentPage: 1,
      importTempVisible: false,
      multipleSelection: []
    };
  },
  created() {
    const echoParams = getCookie({ key: "BRANDLIST", type: "session" });
    if (echoParams) {
      for (let key in echoParams) {
        if (this.hasOwnProperty(key)) {
          this[key] = echoParams[key];
        }
      }
      if (echoParams.startDate && echoParams.endDate) {
        this.date = [
          new Date(echoParams.startDate),
          new Date(echoParams.endDate)
        ];
      }
      this.currentPage = echoParams.pageNo;
    }
  },
  mounted() {
    this.queryList();
  },
  watch: {
    "allBrandActivityList.total": {
      handler(val) {
        if (
          val == (this.currentPage - 1) * this.pageSize &&
          this.pageTotal != 0
        ) {
          this.currentPage -= 1;
          this.queryList();
        }
      },
      deep: true
    }
  },
  computed: mapGetters(["allBrandActivityList", "allBrandList"]),
  methods: {
    importSuccess(spuBrandBoList) {
      this.$store
        .dispatch("importBrand", {
          spuBrandBoList: spuBrandBoList
        })
        .then(res => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.importTempVisible = false;
            this.queryList();
          }
        });
    },
    sortChange(sort) {
      this.sort = sort;
      this.queryList();
    },
    queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        keyWords: this.keyWords,
        order: this.sort.order,
        prop: this.sort.prop
      };
      setCookie({
        key: "BRANDLIST",
        type: "session",
        data: params
      });
      return this.$store.dispatch("queryBrandActivityList", params);
    },
    queryAllList() {
      const params = {
        pageSize: 999999,
        pageNo: 1,
        keyWords: this.keyWords
      };
      return this.$store.dispatch("queryBrandAllList", params);
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    addBrand() {
      this.$router.push({
        name: "AddBrand"
      });
    },
    edit(row) {
      this.$router.push({
        name: "EditBrand",
        query: {
          brandId: row.brandId
        }
      });
    },
    toDetails(row) {
      this.$router.push({
        name: "DetailsBrand",
        query: {
          Detail: "true",
          brandId: row.brandId
        }
      });
    },
    // 导出excel
    output() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryAllList()
          .then(() => {
            const list = this.allBrandList.records;
            list.forEach(v => {
              if (v.isSalesEndDisplay == "true") {
                v.isshow = "显示";
              } else if (v.isSalesEndDisplay == "false") {
                v.isshow = "关闭";
              }
            });

            const tHeader = [
              "品牌名称",
              "品牌logo图",
              "品牌首字母",
              "排序",
              "是否显示",
              "相关商品"
            ];
            const filterVal = [
              "brandName",
              "brandLogo",
              "brandAcronym",
              "seqNum",
              "isshow",
              "relationSpu"
            ];
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(tHeader, data, "品牌列表");
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    remove(row) {
      if (row.relationSpu > 0) {
        this.$message({
          message: "有关联商品的品牌不允许删除",
          type: "warning"
        });
      } else {
        this.$confirm(" 是否确认删除?", "提示", {
          cancelButtonText: "取消",
          confirmButtonText: "确定",
          type: "warning"
        }).then(() => {
          this.$store
            .dispatch("delBrand", {
              brandId: row.brandId
            })
            .then(res => {
              if (res.code === "0") {
                this.$message({
                  message: " 操作成功",
                  type: "success"
                });
                this.queryList();
              }
            });
        });
      }
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    }
  }
};
</script>
<style scoped lang="scss">
.sync {
  background: rgba(255, 248, 225, 1);
  border: 1px solid rgba(248, 216, 117, 1);
  margin-bottom: 10px;
  .refresh {
    width: 28px;
    height: 24px;
    margin-top: 20px;
    margin-left: 20px;

    img {
      width: 100%;
      height: 100%;
    }
  }
  .title {
    height: 14px;
    line-height: 14px;
    font-weight: bold;
    color: rgba(90, 83, 73, 1);
  }
  .describe {
    height: 12px;
    font-size: 12px;
  }
  .switch {
    margin-top: 9px;
    margin-right: 21px;
  }
}
</style>
